import { SubscriptionStatus } from "@/apollo/types";
import { useSubscriptionStatus } from "@/features/subscription";

/** Whether the plan includes Ed. */
export function useEdAvailability() {
  const { status, trial } = useSubscriptionStatus();
  return {
    isEnabled:
      status === SubscriptionStatus.Active ||
      (status === SubscriptionStatus.Freemium && trial?.isActive === true),
  };
}
